import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';

import { hashMD5 } from '../../../../components/Auth/AuthUtils';

import { dataAtualFormatada, horaAtualFormatada } from '../../../../util/FuncoesComuns';
import { imageLogoEctSVG } from '../../../../util/SVGConstants';

import IPreAlertaQtdPendente from '../../interfaces/IPreAlertaQtdPendente';

const downloadResumoPdf = (unitizadores: IPreAlertaQtdPendente[],usuario:any, filtro:string) => {
    (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
 
    const data =dataAtualFormatada('dia', '/');
    const hora = horaAtualFormatada();
    let dataFiltro = filtro;

    let totais = {
        qtdLinhas: 0,
        qtdUnitizadores:0,
        qtdObjs: 0,
        qtdTratLocal:0,
        qtdTratNacional:0,
        qtdPendentes:0,
        qtdFaltantes:0,
        qtdExcluidos:0
    }

    const reportTitle:any = [
          [{
			margin: [25, 25, 25, 5],
            headerRows: 1,
			table: {
                widths: [176,412,180],
                body: [
                    [
                        {
                            svg: imageLogoEctSVG,
                            height: 16,
                            width: 110,
                            alignment: 'center',
                        },
                        {
                            text: 'CONFERÊNCIA ELETRÔNICA',
                            margin: [0, 1.5, 0, 0],
                            alignment: 'center',
                        },
                        {
                            text: `Data: ${data} Hora: ${hora}`,
                            margin: [0, 1.5, 0, 0],
                            alignment: 'center',
                        }
                    ]
                ]
            }
          },
          {
			margin: [25, 3, 25, 5],
            headerRows: 1,
			table: {
                widths: [300,478],
                body: [[                    
                    {
                        text: `Unidade: ${usuario.unidadeSro.codigoSro} - ${usuario.unidadeSro.nome}/${usuario.unidadeSro.superintendencia.sigla}`,
                        fontSize: 9,
                        margin: [0, 1.5, 0, 0],
                        alignment: 'left',
                    },
                    {
                        text: `Filtro: ${dataFiltro}`,
                        fontSize: 9,
                        margin: [0, 1.5, 0, 0],
                        alignment: 'left',
                    }
                ]]
            }
          },
          {
			margin: [25, 3, 5, 3],
            headerRows: 1,
			table: {
                widths: [235,298,235],
                body: [[
                    {
                        text: 'Relatório: RESUMO GERAL',
                        fontSize: 9,
                        margin: [0, 1.5, 0, 0],
                        alignment: 'left',
                    },                    
                    {
                        text: `Usuário: ${usuario.sub} - ${usuario.nome}`,
                        fontSize: 9,
                        margin: [0, 1.5, 0, 0],
                        alignment: 'left',
                    },
                    {
                        text: 'Conferente:',
                        fontSize: 9,
                        margin: [0, 1.5, 0, 0],
                        alignment: 'left',
                    }
                ]]
            }
          }
        ]     
    ];

    const dados = unitizadores.map((uni) => {

        totais.qtdLinhas++;
        totais.qtdObjs+= uni.qtdObjetos || 0;
        totais.qtdUnitizadores+=uni.qtdUnitizadores || 0;
        totais.qtdTratLocal+=uni.qtdObjetosConferidosLocal || 0;
        totais.qtdTratNacional+=uni.qtdObjetosConferidosNacional || 0;
        totais.qtdPendentes+=uni.qtdObjetosPendentes || 0;
        totais.qtdFaltantes+=uni.qtdObjetosFaltantes || 0;
        totais.qtdExcluidos+=uni.qtdObjetosExcluidos || 0;

        return [
            {text: uni.dataExpedicao, fontSize: 8, margin: [0,0,0,0]},
            {text: uni.qtdUnitizadores, fontSize: 8, alignment:'center',margin: [0,0,0,0]},
            {text: uni.qtdObjetos || '0', fontSize: 8, alignment:'center', margin: [0,0,0,0]},
            {text: uni.qtdObjetosPendentes || '0', fontSize: 8, alignment:'center', margin: [0,0,0,0]},
            {text: uni.qtdObjetosConferidosLocal || '0', fontSize: 8, alignment:'center', margin: [0,0,0,0]},
            {text: uni.qtdObjetosConferidosNacional || '0', fontSize: 8, alignment:'center', margin: [0,0,0,0]},
            {text: uni.qtdObjetosFaltantes || '0', fontSize: 8, alignment:'center', margin: [0,0,0,0]},
            {text: uni.qtdObjetosExcluidos || '0', fontSize: 8, alignment:'center', margin: [0,0,0,0]}
        ] 
    });

    let qtdListas = totais.qtdLinhas <= 1 ? `${totais.qtdLinhas} Linha.` : `${totais.qtdLinhas} Linhas.`
    const detailsTotais:any = [                           
                        {text: qtdListas, fontSize: 9, margin: [15,0,0,0],alignment: 'left',bold: true,border: [true,true,true,true]},
                        {text: totais.qtdUnitizadores, fontSize: 8, alignment:'center',bold: true, margin: [0,0,0,0]},
                        {text: totais.qtdObjs, fontSize: 8, alignment:'center',bold: true, margin: [0,0,0,0]},
                        {text: totais.qtdTratLocal, fontSize: 8, alignment:'center',bold: true, margin: [0,0,0,0]},
                        {text: totais.qtdTratNacional, fontSize: 8, alignment:'center',bold: true, margin: [0,0,0,0]},
                        {text: totais.qtdPendentes, fontSize: 8, alignment:'center',bold: true, margin: [0,0,0,0]},
                        {text: totais.qtdFaltantes, fontSize: 8, alignment:'center',bold: true, margin: [0,0,0,0]},
                        {text: totais.qtdExcluidos, fontSize: 8, alignment:'center',bold: true, margin: [0,0,0,0]}                   
    ];

    dados.push(detailsTotais);

    const details:any = [
        {
            table:{
                headerRows: 1,
                widths: [120, 80, 80,80,80, 80, 80, 80],
                body: [
                    [
                        {text: 'Data', style: 'tableHeader', fontSize: 9},
                        {text: 'Qtd Unitizadores', style: 'tableHeader', fontSize: 9, alignment:'center'},
                        {text: 'Qtd Objetos', style: 'tableHeader', fontSize: 9, alignment:'center'},
                        {text: 'Qtd Pendentes', style: 'tableHeader', fontSize: 9, alignment:'center'},
                        {text: 'Qtd Conf. Local', style: 'tableHeader', fontSize: 9, alignment:'center'},
                        {text: 'Qtd Conf. Nacional', style: 'tableHeader', fontSize: 9, alignment:'center'},
                        {text: 'Qtd Faltantes', style: 'tableHeader', fontSize: 9, alignment:'center'},
                        {text: 'Qtd Excluídos', style: 'tableHeader', fontSize: 9, alignment:'center'}
                    ],
                    ...dados
                ]
            },
            margin: [13, 5, 25, 5],
            layout: 'lightHorizontalLines' // headerLineOnly
        }
    ];

    function Rodape(currentPage: Number, pageCount: Number){

        let hash=hashMD5(`${usuario.unidadeSro.codigoSro}${usuario.sub}${data} ${hora}${totais.qtdLinhas}`).toString();

        return [
            {
            widths: [768],
            margin: [25, 5, 25, 5],
            headerRows: 1,
            columns:[{
              text: `Identificador documento: ${hash.toUpperCase()}`,
              alignment: 'left',
              fontSize: 9,
            },
            {
                text: `Página ${currentPage} de ${pageCount}`,
                alignment: 'right',
                fontSize: 9,
            }]}
        ]
    }

    const docDefinitios: any = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [15, 105, 15, 30],
        header: [reportTitle],
        content: [details],
        footer: Rodape
    }

    pdfMake.createPdf(docDefinitios).download(`ResumoGerado_${data.replaceAll('/','')}.pdf`);
}

export default downloadResumoPdf;